import React from "react";
import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";

export default function TripAppVersionDetails({ label, appVersion }) {
    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                selectedValue={appVersion}
            />
        </EuiFlexItem>
    );
}
